// src/utils/constants.js
export const API = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const PARTICLE_COLORS = ["#9b7fd4", "#c9a84c", "#7b5ea7", "#e8c97a", "#ffffff"];

export const BANNER_ICONS = [
  "Sword","Trees","Megaphone","Pickaxe","Castle",
  "Newspaper","Sparkles","Trophy","Crown","Package","Mountain","Coins",
];

export function fmtDate(dateStr) {
  const d = new Date(dateStr);
  return {
    day: String(d.getDate()).padStart(2, "0"),
    mon: d.toLocaleString("en-GB", { month: "short" }).toUpperCase(),
  };
}


export function fmtDateTime(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export function fmtRelative(dateStr) {
  if (!dateStr) return "—";
  const then = new Date(dateStr).getTime();
  if (Number.isNaN(then)) return "—";
  const diff = Date.now() - then;
  const abs = Math.abs(diff);
  const future = diff < 0;
  const units = [
    [86400000 * 365, "year"],
    [86400000 * 30, "month"],
    [86400000 * 7, "week"],
    [86400000, "day"],
    [3600000, "hour"],
    [60000, "minute"],
  ];
  for (const [ms, label] of units) {
    if (abs >= ms) {
      const n = Math.max(1, Math.floor(abs / ms));
      return future ? `in ${n} ${label}${n === 1 ? "" : "s"}` : `${n} ${label}${n === 1 ? "" : "s"} ago`;
    }
  }
  return "just now";
}

export function fmtMoney(amount, currency = "GBP") {
  const value = Number(amount || 0);
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: String(currency || "GBP").toUpperCase(),
      maximumFractionDigits: 2,
    }).format(Number.isFinite(value) ? value : 0);
  } catch {
    return `${String(currency || "GBP").toUpperCase()} ${(Number.isFinite(value) ? value : 0).toFixed(2)}`;
  }
}

export function statusStyle(status) {
  const key = String(status || "pending").toLowerCase();
  const map = {
    pending:    { bg: "rgba(240,216,120,.10)", border: "rgba(240,216,120,.28)", color: "#f0d878" },
    approved:   { bg: "rgba(74,222,128,.10)", border: "rgba(74,222,128,.28)", color: "#4ade80" },
    fulfilled:  { bg: "rgba(74,222,128,.10)", border: "rgba(74,222,128,.28)", color: "#4ade80" },
    paid:       { bg: "rgba(96,165,250,.10)", border: "rgba(96,165,250,.28)", color: "#60a5fa" },
    delivered:  { bg: "rgba(74,222,128,.10)", border: "rgba(74,222,128,.28)", color: "#4ade80" },
    shipped:    { bg: "rgba(96,165,250,.10)", border: "rgba(96,165,250,.28)", color: "#60a5fa" },
    processing: { bg: "rgba(167,139,250,.10)", border: "rgba(167,139,250,.28)", color: "#a78bfa" },
    rejected:   { bg: "rgba(248,113,113,.10)", border: "rgba(248,113,113,.28)", color: "#f87171" },
    failed:     { bg: "rgba(248,113,113,.10)", border: "rgba(248,113,113,.28)", color: "#f87171" },
    refunded:   { bg: "rgba(148,163,184,.10)", border: "rgba(148,163,184,.28)", color: "#94a3b8" },
    partially_refunded: { bg: "rgba(251,191,36,.10)", border: "rgba(251,191,36,.28)", color: "#fbbf24" },
    returned:    { bg: "rgba(148,163,184,.10)", border: "rgba(148,163,184,.28)", color: "#94a3b8" },
    cancelled:  { bg: "rgba(148,163,184,.10)", border: "rgba(148,163,184,.28)", color: "#94a3b8" },
  };
  return map[key] || { bg: "rgba(123,94,167,.10)", border: "rgba(123,94,167,.28)", color: "var(--purpleB)" };
}
